module.exports = __webpack_public_path__ + "static/img/bg_04.b7b446a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/themes/bg_04.jpg
// module id = 8faF
// module chunks = 29